<template>
  <div :class="['row blog-container', { 'blog-container-mobile': isSmallScreen }]">
    <div
      v-if="!isSmallScreen"
      :class="[
        'col-3 blog-sidebar q-pt-md flex column',
        $q.screen.width > 1200 ? 'q-px-xl' : 'q-px-md',
      ]"
    >
      <div class="logo-wrapper border-radius-20 relative-position">
        <img
          class="logo cursor-pointer absolute"
          :src="logo"
          :alt="settings.metaFields.metaTitle"
          :width="headerLogoAttributes.width"
          :height="headerLogoAttributes.height"
          @click="router.push({ name: ROUTES.RENDER.BLOG })"
        >
      </div>

      <q-icon
        v-if="isPostPage"
        name="img:arrow-left.svg"
        :class="[
          'return-button q-pa-md border-radius-20 cursor-pointer',
          { 'for-big-screen': $q.screen.width > 1600 },
        ]"
        size="30px"
        @click="router.push({ name: ROUTES.RENDER.BLOG })"
      />
    </div>
    <div :class="['col', isSmallScreen ? 'q-pb-md' : 'q-pb-xl']">
      <div
        v-if="!isSmallScreen"
        class="blog-header-menu border-radius-12 q-mt-md z-max"
      >
        <RenderHeaderMenu class="flex items-center justify-center" />
      </div>
      <MobileMenuHeader
        v-else
        :logo="logo"
        class="blog-header-mobile"
        :logo-attributes="headerLogoAttributes"
        @click="$refs.mobileMenuRef.toggle()"
      />
      <q-expansion-item
        v-if="isPostPage && isSmallScreen && anchors && anchors.length > 0"
        expand-icon="img:chevron-down.svg"
        class="anchors-area"
        :label="$t('text.tableContent')"
        style="height: 50px; max-width: 100vw;"
      >
        <ul class="anchor-list anchor-list-mobile flex column gap-sm q-px-md q-pb-lg">
          <li
            v-for="anchor in anchors"
            :key="anchor.title"
            class="anchor-item anchor-item-mobile q-pl-md cursor-pointer"
            @click="scrollTo(anchor.element)"
          >
            {{ anchor.title }}
          </li>
        </ul>
      </q-expansion-item>
      <router-view @subscribe="onSubscribe" />
    </div>
    <div
      v-if="!isSmallScreen"
      :class="[
        'col-3 blog-sidebar q-py-md',
        $q.screen.width > 1200 ? 'q-px-xl' : 'q-px-md',
      ]"
    >
      <div class="sidebar-content">
        <BlogBanner
          v-if="settings.metaFields.banner"
          class="blog-banner"
          :banner="settings.metaFields.banner"
        />
        <Newsletter
          v-if="settings.isNewsletterEnabled"
          :meta-fields="settings.metaFields"
          :class="{ 'no-banner': !settings.metaFields.banner }"
          @subscribe="onSubscribe"
        />
      </div>
    </div>
    <BlogBanner
      v-if="settings.metaFields.banner && !isPostPage && isSmallScreen"
      class="mobile-banner"
      :banner="settings.metaFields.banner"
    />
    <Newsletter
      v-if="settings.isNewsletterEnabled && !isPostPage && isSmallScreen"
      class="newsletter-form-mobile"
      :metaFields="settings.metaFields"
      @subscribe="onSubscribe"
    />
    <q-drawer
      v-if="isSmallScreen"
      ref="mobileMenuRef"
      value
      behavior="mobile"
      side="right"
      :width="$q.screen.width"
      class="mobile-menu"
    >
      <MobileMenuHeader
        :logo="logo"
        :logo-attributes="headerLogoAttributes"
        class="mobile-menu-header"
        button-icon="img:x.svg"
        @click="$refs.mobileMenuRef.hide()"
      />
      <RenderHeaderMenu
        class="flex column q-px-lg"
        @click="$refs.mobileMenuRef.hide()"
      />
    </q-drawer>
  </div>
</template>
<script setup>
import { ROUTES } from 'src/enums';
import Newsletter from 'components/Newsletter.vue';
import RenderHeaderMenu from 'components/render/RenderHeaderMenu.vue';
import MobileMenuHeader from 'components/MobileMenuHeader.vue';
import BlogBanner from 'components/BlogBanner.vue';
import useRender from 'src/composables/useRender';
import { useRouter } from 'vue-router';

const router = useRouter();

const {
  isSmallScreen,
  logo,
  headerLogoAttributes,
  settings,
  onSubscribe,
  anchors,
  isPostPage,
  scrollTo,
} = useRender();
</script>

<style lang="scss" scoped>
.logo-wrapper {
  height: 0;
  padding-bottom: 100%;
  background: var(--blog-card-color, $grey-1);
  position: sticky;
  top: 16px;

  .logo {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}

.sidebar-content {
  position: sticky;
  top: 16px;
}
</style>

<style lang="scss" scoped>
.newsletter-form-mobile, .mobile-banner {
  max-width: unset !important;
  margin: 16px 32px !important;
}

.return-button {
  position: sticky;
  top: calc(100vH - 120px);
}

.no-banner {
  margin-top: 0 !important;
}
</style>
